import { useContext } from 'react'

import type { AppBrand } from '../constants'
import {
  AppBrandContext,
  type AppBrandContextValue
} from '../providers/AppBrandProvider'
import { getAppBrand } from '../utils/getAppBrand'
import { getBrandName } from '../utils/getBrandName'

export function useAppBrand(): AppBrand {
  return useContext(AppBrandContext)?.appBrand ?? getAppBrand()
}

export function useAppBrandState(): AppBrandContextValue {
  const appBrandContext = useContext(AppBrandContext)
  if (appBrandContext) {
    return appBrandContext
  }

  const appBrand = getAppBrand()

  return {
    appBrand,
    brandName: getBrandName(appBrand),
    resetAppBrand: () => {},
    setAppBrand: () => {}
  }
}

export function useAppBrandName(): string {
  return useAppBrandState().brandName
}
